import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FunctiiComponent } from './functii.component';
import { MaterialModule } from 'src/app/material.module';
import { AddFunctiiComponent } from './add-functii/add-functii.component';
import { EditFunctiiComponent } from './edit-functii/edit-functii.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [FunctiiComponent, AddFunctiiComponent, EditFunctiiComponent],
  imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
  exports: [FunctiiComponent],
})
export class FunctiiModule {}
